module.exports = __webpack_public_path__ + "static/media/Layout17.b3da8b96.png";